export default __webpack_public_path__ + "static/media/company9.7856e63b.png";